<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from "axios";


export default {
	name: "App",
	beforeCreate() {
		const url = process.env.ROOT_API;
		axios.get(url + "/email/ligarApi").catch(() => {
			axios.get(url + "/email/ligarApi").catch(() => {
				axios.get(url + "/email/ligarApi");
			});
		});
	},
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400&display=swap');
h1,h2,h3,h4,h5,h6{
  font-family: 'Poppins', sans-serif !important;
}
*,span,p{
  font-family: 'Poppins', sans-serif !important;
}
.gap-xll{
  gap: 100px;
}
.gap-xl{
  gap: 75px;
}
.gap-lg{
  gap:50px;
}
.gap-md{
  gap: 35px;
}
.gap-sm{
  gap: 15px;
}
.borda {
    box-shadow: 0px 0px 2px 0px grey;
    min-height: 80vh;
    justify-content: center;
    background-color: white !important;
}
#app{
  background-color: whitesmoke;
}
@media screen and (max-width:1200px){
    #logo{
        width: 75% !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue